import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretLargeLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	fill: "currentColor",
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M20.2929 4.29289c.3905-.39052 1.0237-.39052 1.4142 0 .3605.36049.3882.92772.0832 1.32001l-.0832.09421L11.415 16l10.2921 10.2929c.3605.3605.3882.9277.0832 1.32l-.0832.0942c-.3605.3605-.9277.3882-1.32.0832l-.0942-.0832-11.00001-11c-.36048-.3605-.38821-.9277-.08319-1.32l.08319-.0942L20.2929 4.29289Z" })
});
export default SvgCaretLargeLeft;
